'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode, createComponentVNode, normalizeProps } from "inferno";
import { Adapter } from 'component-registry';
import { Component } from 'inferno';
import { findDOMNode } from 'inferno-extras';
import { safeGet } from 'safe-utils';
import { renderString } from './common';
import { i18n } from 'isomorphic-schema';
import { animateOnAdd, animateOnRemove } from 'inferno-animation';
import { interfaces } from 'isomorphic-schema';
import { IListRowContainerWidget } from '../interfaces';
import getWidgetAdapters from '../getWidgetAdapters';
import { Button } from 'inferno-bootstrap';

var ListRowContainerWidget = /*#__PURE__*/function (_Component) {
  _inherits(ListRowContainerWidget, _Component);

  function ListRowContainerWidget(props) {
    var _this;

    _classCallCheck(this, ListRowContainerWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListRowContainerWidget).call(this, props));
    _this.doMakeDraggable = _this.doMakeDraggable.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.doMakeUndraggable = _this.doMakeUndraggable.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ListRowContainerWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isFirstMount) {
        animateOnAdd(findDOMNode(this), 'InfernoFormlib-ListFieldRow--Animation');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var domEl = findDOMNode(this);
      animateOnRemove(domEl, 'InfernoFormlib-ListFieldRow--Animation');
    }
  }, {
    key: "doMakeDraggable",
    value: function doMakeDraggable(e) {
      findDOMNode(this).setAttribute('draggable', true);
    }
  }, {
    key: "doMakeUndraggable",
    value: function doMakeUndraggable(e) {
      findDOMNode(this).removeAttribute('draggable');
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var _this2 = this;

      var children = _ref.children,
          className = _ref.className,
          options = _ref.options;
      return createVNode(1, "div", "InfernoFormlib-ListFieldRow" + (className ? ' ' + className : ''), [createVNode(1, "div", "InfernoFormlib-DragHandle", null, 1, {
        "onMouseDown": this.doMakeDraggable,
        "onMouseUp": this.doMakeUndraggable
      }), children, createVNode(1, "div", "InfernoFormlib-ListFieldRowDeleteBtnWrapper", createComponentVNode(2, Button, {
        "className": "InfernoFormlib-ListFieldRowDeleteBtn",
        "color": "danger",
        "onClick": function onClick(e) {
          e.preventDefault();

          _this2.props.onDelete();
        },
        children: renderString(i18n('inferno-formlib--ListField_remove', 'Remove'), options && options.lang, 'Remove')
      }), 2)], 0, {
        "data-drag-index": this.props['data-drag-index']
      });
    }
  }]);

  return ListRowContainerWidget;
}(Component);

new Adapter({
  implements: IListRowContainerWidget,
  adapts: interfaces.IListField,
  Component: ListRowContainerWidget
});

function renderRows(_ref2) {
  var field = _ref2.field,
      value = _ref2.value,
      lang = _ref2.lang,
      namespace = _ref2.namespace,
      inputName = _ref2.inputName,
      itemKeys = _ref2.itemKeys,
      validationErrors = _ref2.validationErrors,
      customWidgets = _ref2.customWidgets,
      onInput = _ref2.onInput,
      onChange = _ref2.onChange,
      _onDelete = _ref2.onDelete,
      isMounted = _ref2.isMounted;
  if (value === undefined) return;
  return value.map(function (item, index) {
    // Respect maxLength
    if (field.maxLength !== undefined && field.maxLength <= index) return;
    var valueType = field.valueType;
    var validationError = safeGet(function () {
      return validationErrors.errors[index];
    }); // Support readOnly
    // Support validation constraints    

    var myNamespaceByKey = namespace.concat([itemKeys[index].key]); // .concat returns a new array

    var myNamespace = namespace.concat([index]);
    var dotName = myNamespace.join('.'); // Unpack the invariant errors so they can be found by field key

    var tmpInvariantErrors = safeGet(function () {
      return validationErrors && validationErrors.invariantErrors && validationErrors.invariantErrors.filter(function (invErr) {
        // Pattern match field name of error with current namespace to see if it is a match
        return invErr.fields.reduce(function (prev, curr) {
          return prev || curr.indexOf(dotName) === 0;
        }, false);
      });
    });

    if (Array.isArray(tmpInvariantErrors) && tmpInvariantErrors.length > 0) {
      if (!validationError) validationError = {};
      validationError.invariantErrors = tmpInvariantErrors;
    }

    var _getWidgetAdapters = getWidgetAdapters(valueType, myNamespaceByKey.join('.'), customWidgets),
        InputFieldAdapter = _getWidgetAdapters.InputFieldAdapter,
        RowAdapter = _getWidgetAdapters.RowAdapter;

    var InputField = InputFieldAdapter.Component;
    var Row = RowAdapter.Component; // We need to know if this should be animated

    var justAdded = itemKeys[index].justAdded;
    itemKeys[index].justAdded = false;
    var newInputName = inputName && index ? inputName + '[' + index + ']' : inputName || index;
    var ListRowContainer = new IListRowContainerWidget(field).Component;
    var doesNotRenderLabel = RowAdapter.doesNotRenderLabel();
    var sharedProps = {
      namespace: myNamespace,
      propName: index,
      value: value && value[index],
      options: {
        parentValue: value,
        lang: lang
      },
      validationError: validationError,
      formIsMounted: isMounted && !justAdded,
      doesNotRenderLabel: doesNotRenderLabel,
      id: dotName,
      // Callbacks
      onChange: onChange,
      onInput: onInput
    };
    return createComponentVNode(2, ListRowContainer, {
      "className": "InfernoFormlib-DragItem",
      "data-drag-index": index,
      "isFirstMount": !isMounted,
      "propName": index,
      "value": value[index],
      "validationError": validationError,
      "onChange": onChange,
      "onDelete": function onDelete() {
        return _onDelete(index);
      },
      children: normalizeProps(createComponentVNode(2, Row, _objectSpread({
        "adapter": RowAdapter
      }, sharedProps, {
        children: normalizeProps(createComponentVNode(2, InputField, _objectSpread({
          "adapter": InputFieldAdapter,
          "inputName": newInputName,
          "customWidgets": customWidgets
        }, sharedProps)))
      })))
    }, myNamespaceByKey.join('.'));
  });
}

function Placeholder(props) {
  return createVNode(1, "div", "InfernoFormlib-ListFieldPlaceholderContainer", createVNode(1, "div", "InfernoFormlib-ListFieldPlaceholder", createVNode(1, "div", "InfernoFormlib-ListFieldPlaceholderText", props.text, 0), 2), 2);
}

export { ListRowContainerWidget, Placeholder, renderRows };